import Biscuit from '../../utils/Biscuit';

type Props= {
    url?: string,
    eventHandler?: (event: any) => void,
    label?: string,
    icon?: string,
    id?: string
}
const Button = (props:Props) => {
    const {url,eventHandler,label, icon, id} = props;
    return (
        <>
            {typeof eventHandler === 'undefined' ? <><a
                href={url}
                id={id}
                className={"button beautify beautify-" + Biscuit.get('user.client_id')}
            >
                <i className={"fi "+icon}></i>
                <span style={{marginLeft:"10px;"}}>
              {label}
          </span>
            </a></>:<>
                <a
                    href={"#"}
                    onClick={eventHandler}
                    id={id}
                    className={"button beautify beautify-" + Biscuit.get('user.client_id')}
                >
                    <i className={"fi "+icon}></i>
                    <span style={{marginLeft:"10px;"}}>
              {label}
          </span>
                </a>
            </>}
        </>
    );
};
export default Button;